import { Card, CardContent, Typography } from "@mui/material";
import { Transaction } from "@appTypes/index";
import formatDate from "@utils/formatDate";

interface PurchaseCardProps {
  transaction: Transaction;
}

const PurchaseCard = ({ transaction }: PurchaseCardProps) => {
  const date = formatDate(
    transaction.transactionDate,
    { month: "short", day: "numeric", year: "numeric" }
  );

  return (
    <Card
      elevation={0}
      className="mb-3 rounded-lg"
    >
      <CardContent sx={{ "&:last-child": { pb: 2 } }}>
        <div className="flex items-center justify-between mb-1">
          <Typography variant="body2" className="font-bold">
            {transaction.productName}
          </Typography>
        </div>
        <div className="flex items-center justify-between">
          <Typography variant="caption" color="text.secondary">
            {date}
          </Typography>
          <Typography variant="body2" className="font-semibold">
            ${transaction.amount.toFixed(2)}
          </Typography>
        </div>
      </CardContent>
    </Card>
  );
};

export default PurchaseCard;
